import Railroad from "../../../../src/components/railroad";
import { Rail as FunctionRail } from "../../../../src/commands/function.ts";
import * as React from 'react';
export default {
  Railroad,
  FunctionRail,
  React
};